module.exports = generateBoundsFunction;
module.exports.generateFunctionBody = generateBoundsFunctionBody;
var createPatternBuilder = require('./createPatternBuilder');
function generateBoundsFunction(dimension) {
  var code = generateBoundsFunctionBody(dimension);
  return new Function('bodies', 'settings', 'random', code);
}
function generateBoundsFunctionBody(dimension) {
  var pattern = createPatternBuilder(dimension);
  var code = "\n  var boundingBox = {\n    ".concat(pattern('min_{var}: 0, max_{var}: 0,', {
    indent: 4
  }), "\n  };\n\n  return {\n    box: boundingBox,\n\n    update: updateBoundingBox,\n\n    reset: resetBoundingBox,\n\n    getBestNewPosition: function (neighbors) {\n      var ").concat(pattern('base_{var} = 0', {
    join: ', '
  }), ";\n\n      if (neighbors.length) {\n        for (var i = 0; i < neighbors.length; ++i) {\n          let neighborPos = neighbors[i].pos;\n          ").concat(pattern('base_{var} += neighborPos.{var};', {
    indent: 10
  }), "\n        }\n\n        ").concat(pattern('base_{var} /= neighbors.length;', {
    indent: 8
  }), "\n      } else {\n        ").concat(pattern('base_{var} = (boundingBox.min_{var} + boundingBox.max_{var}) / 2;', {
    indent: 8
  }), "\n      }\n\n      var springLength = settings.springLength;\n      return {\n        ").concat(pattern('{var}: base_{var} + (random.nextDouble() - 0.5) * springLength,', {
    indent: 8
  }), "\n      };\n    }\n  };\n\n  function updateBoundingBox() {\n    var i = bodies.length;\n    if (i === 0) return; // No bodies - no borders.\n\n    ").concat(pattern('var max_{var} = -Infinity;', {
    indent: 4
  }), "\n    ").concat(pattern('var min_{var} = Infinity;', {
    indent: 4
  }), "\n\n    while(i--) {\n      // this is O(n), it could be done faster with quadtree, if we check the root node bounds\n      var bodyPos = bodies[i].pos;\n      ").concat(pattern('if (bodyPos.{var} < min_{var}) min_{var} = bodyPos.{var};', {
    indent: 6
  }), "\n      ").concat(pattern('if (bodyPos.{var} > max_{var}) max_{var} = bodyPos.{var};', {
    indent: 6
  }), "\n    }\n\n    ").concat(pattern('boundingBox.min_{var} = min_{var};', {
    indent: 4
  }), "\n    ").concat(pattern('boundingBox.max_{var} = max_{var};', {
    indent: 4
  }), "\n  }\n\n  function resetBoundingBox() {\n    ").concat(pattern('boundingBox.min_{var} = boundingBox.max_{var} = 0;', {
    indent: 4
  }), "\n  }\n");
  return code;
}